import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { TableEditMode } from '@connect-services/client/components/entity-table/entity-table.component';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { ToggleComponent } from '@shared/client/components/toggle/toggle.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RessourcesModule, ToggleComponent],
    selector: 'app-entity-table-edit-toolbar',
    styleUrl: './entity-table-edit-toolbar.component.scss',
    templateUrl: './entity-table-edit-toolbar.component.html',
})
export class EntityTableEditToolbarComponent {
    public readonly canDelete = input.required<boolean>();
    public readonly canRedoEdit = input.required<boolean>();
    public readonly canUndoEdit = input.required<boolean>();
    public readonly canUseGlobalEditButton = input.required<boolean>();
    public readonly canUseTableEditToggle = input.required<boolean>();
    public readonly canValidate = input.required<boolean>();
    public readonly currentTableEditMode = input.required<TableEditMode>();
    public readonly deleteEntities = output<void>();
    public readonly deleteTooltip = input.required<string>();
    public readonly editModeTooltip = computed<string | undefined>(() => {
        if (this.canUseGlobalEditButton()) {
            return undefined;
        }

        return 'insufficientPermissions';
    });
    public readonly isEditable = input<boolean>(true);
    public readonly isEditionInProgress = input<boolean>(false);
    public readonly isEditModeActive = input.required<boolean>();
    public readonly redoEdit = output<void>();
    public readonly redoTooltip = computed<string>(() => {
        if (this.isEditionInProgress()) {
            return 'editMode.undoRedoUnavailableDuringEntityEdition';
        }

        return this.canRedoEdit() ? 'redoLastAction' : 'nothingToRedo';
    });
    public readonly switchToggledMode = output<boolean>();
    public readonly tableEditToggleTooltip = computed<string | undefined>(() => {
        if (!this.isEditable()) {
            return 'editMode.layerStandardNotEditable';
        }

        if (this.canUseTableEditToggle()) {
            return undefined;
        }

        return 'insufficientPermissions';
    });
    public readonly toggleEditMode = output<void>();
    public readonly undoEdit = output<void>();
    public readonly undoTooltip = computed<string>(() => {
        if (this.isEditionInProgress()) {
            return 'editMode.undoRedoUnavailableDuringEntityEdition';
        }

        return this.canUndoEdit() ? 'undoLastAction' : 'nothingToUndo';
    });

    public readonly validateEntities = output<void>();
    protected readonly ButtonType = ButtonType;

    public isTableEditMode(): boolean {
        return this.isEditable() && this.isEditModeActive() && this.currentTableEditMode() === TableEditMode.TABLE_EDIT;
    }
}
